export const OBSERVER_NO_ACCESS_COPY = {
  headline: 'Ninety Mobile is available to team members with a paid seat.',
  body: "You're an Observer in this company. Ask your admin to upgrade your role, or view Ninety on the web.",
} as const;
